/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type JiraEditEpicsModal_QueryVariables = {};
export type JiraEditEpicsModal_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"JiraEditEpicsModal_viewer">;
    } | null;
};
export type JiraEditEpicsModal_Query = {
    readonly response: JiraEditEpicsModal_QueryResponse;
    readonly variables: JiraEditEpicsModal_QueryVariables;
};



/*
query JiraEditEpicsModal_Query {
  viewer {
    actualPersonId
    component(name: "jira_edit_epics_modal")
    ...JiraEditEpicsModal_viewer
    id
  }
}

fragment JiraEditEpicsModal_viewer on Viewer {
  id
  availableFeatureFlags {
    key
    id
  }
  project {
    id
    jiraCloudEpicIds
  }
  company {
    id
    modules {
      moduleType
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "jira_edit_epics_modal"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"jira_edit_epics_modal\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "JiraEditEpicsModal_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "JiraEditEpicsModal_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "JiraEditEpicsModal_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureFlag",
            "kind": "LinkedField",
            "name": "availableFeatureFlags",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraCloudEpicIds",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Module",
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moduleType",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "JiraEditEpicsModal_Query",
    "operationKind": "query",
    "text": "query JiraEditEpicsModal_Query {\n  viewer {\n    actualPersonId\n    component(name: \"jira_edit_epics_modal\")\n    ...JiraEditEpicsModal_viewer\n    id\n  }\n}\n\nfragment JiraEditEpicsModal_viewer on Viewer {\n  id\n  availableFeatureFlags {\n    key\n    id\n  }\n  project {\n    id\n    jiraCloudEpicIds\n  }\n  company {\n    id\n    modules {\n      moduleType\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '93e065676b814da9d09eebe21599b3db';
export default node;
